export default __webpack_public_path__ + "img/status-screen.293dd391.jpg";